import Seo from "../components/Seo";
import { Reveal } from "../components/Reveal";
import { BeforeAfterSlider } from "../components/BeforeAfterSlider";
import { SectionHeading, CTABand } from "../components/blocks";
import { BEFORE_AFTER, IMAGES } from "../lib/data";
import { Info } from "lucide-react";

const GALLERY = [
  { src: IMAGES.roofAfter, title: "Toiture rénovée", loc: "Oise" },
  { src: IMAGES.facadeAfter, title: "Façade ravalée", loc: "Île-de-France" },
  { src: IMAGES.gutterAfter, title: "Gouttières zinc neuves", loc: "Picardie" },
  { src: IMAGES.roofer1, title: "Chantier de couverture", loc: "Oise" },
  { src: IMAGES.tileTexture, title: "Pose de tuiles", loc: "Oise" },
  { src: IMAGES.facadeModern, title: "Rénovation extérieure", loc: "Île-de-France" },
];

export default function Realisations() {
  return (
    <div>
      <Seo
        title="Réalisations — Avant / Après | Carnier Toiture et Habitat (Oise)"
        description="Découvrez nos réalisations de rénovation de toiture, ravalement de façade et gouttières dans l'Oise, l'Île-de-France et la Picardie. Comparatifs avant / après."
      />

      <section className="bg-vegetal-800 text-white">
        <div className="max-w-7xl mx-auto px-5 md:px-10 py-16 md:py-20">
          <Reveal>
            <span className="text-xs uppercase tracking-[0.22em] font-semibold text-terracotta-300">Réalisations</span>
            <h1 className="mt-3 font-heading text-4xl sm:text-5xl font-bold tracking-tight text-balance">Nos transformations avant / après</h1>
            <p className="mt-5 max-w-2xl text-vegetal-100/80 text-lg">Faites glisser le curseur pour visualiser le résultat de nos interventions.</p>
          </Reveal>
        </div>
      </section>

      <section className="max-w-7xl mx-auto px-5 md:px-10 py-8 -mt-8">
        <Reveal>
          <div className="flex items-start gap-3 rounded-lg bg-terracotta-50 border border-terracotta-100 p-4 text-sm text-terracotta-800">
            <Info className="h-5 w-5 shrink-0 mt-0.5" />
            <p>Nos photos de chantiers réels arrivent prochainement. Les visuels ci-dessous sont des illustrations réalistes représentatives de la qualité de nos prestations.</p>
          </div>
        </Reveal>
      </section>

      <section className="max-w-7xl mx-auto px-5 md:px-10 py-12">
        <div className="grid md:grid-cols-3 gap-8">
          {BEFORE_AFTER.map((b, i) => (
            <Reveal key={b.title} delay={i * 90}>
              <div>
                <BeforeAfterSlider before={IMAGES[b.before]} after={IMAGES[b.after]} alt={b.title} />
                <h3 className="mt-4 font-heading text-lg font-semibold text-neutral-900">{b.title}</h3>
                <p className="text-sm text-neutral-600 mt-1">{b.desc}</p>
                <span className="inline-block mt-2 text-xs font-medium text-vegetal-600 uppercase tracking-wider">{b.location}</span>
              </div>
            </Reveal>
          ))}
        </div>
      </section>

      <section className="max-w-7xl mx-auto px-5 md:px-10 py-12 md:py-20">
        <Reveal>
          <SectionHeading center overline="Galerie" title="Un aperçu de notre savoir-faire" />
        </Reveal>
        <div className="mt-12 columns-1 sm:columns-2 lg:columns-3 gap-5 [&>*]:mb-5">
          {GALLERY.map((g, i) => (
            <Reveal key={g.title} delay={(i % 3) * 70}>
              <div className="relative group rounded-xl overflow-hidden shadow-sm ring-1 ring-black/5 break-inside-avoid">
                <img src={g.src} alt={g.title} className="w-full object-cover group-hover:scale-105 transition-transform duration-500" />
                <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/0 to-transparent opacity-0 group-hover:opacity-100 transition-opacity" />
                <div className="absolute bottom-0 left-0 right-0 p-4 translate-y-2 group-hover:translate-y-0 opacity-0 group-hover:opacity-100 transition-all">
                  <p className="text-white font-medium">{g.title}</p>
                  <p className="text-white/70 text-sm">{g.loc}</p>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </section>

      <CTABand />
    </div>
  );
}
